import VaspsTableItem from './VaspsTableItem'

export default VaspsTableItem
